module.exports = __webpack_public_path__ + "static/media/icon-family.280e1fd9.svg";